"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _AlertComponent = _interopRequireDefault(require("@insided/shared/uikit/AlertComponent"));

var _Button = _interopRequireDefault(require("@insided/shared/uikit/Button"));

var ConfiguratorFooter = function ConfiguratorFooter(_ref) {
  var errorMessage = _ref.errorMessage,
      isLoading = _ref.isLoading,
      onSave = _ref.onSave,
      discardChanges = _ref.discardChanges,
      onCloseError = _ref.onCloseError;
  return (0, _preact.h)("div", {
    className: "theme-configurator--footer"
  }, errorMessage !== '' && (0, _preact.h)(_AlertComponent.default, {
    messageType: "error",
    message: errorMessage,
    renderHTML: true,
    onClose: onCloseError
  }), (0, _preact.h)("div", {
    className: "theme-configurator--buttons"
  }, (0, _preact.h)(_Button.default, {
    isLoading: isLoading,
    size: "medium",
    variant: "save",
    onClick: onSave,
    "data-qa": "theme-configurator-publish"
  }, "Publish"), (0, _preact.h)(_Button.default, {
    variant: "secondary",
    size: "medium",
    onClick: discardChanges,
    "data-qa": "theme-configurator-cancel"
  }, "Cancel")));
};

var _default = ConfiguratorFooter;
exports.default = _default;